import React from "react";
import { Loader2 } from "lucide-react";
import { useCustomSiteBackdrop } from "@/hooks/useCustomSiteBackdrop";
import { cn } from "@/lib/utils";

/**
 * Loading fallback component for public routes.
 * Provides a clean loading state while page content loads.
 */
export default function PublicLoadingFallback() {
  const { isActive: overVideo } = useCustomSiteBackdrop();

  return (
    <div 
      className={cn(
        "flex items-center justify-center transition-colors duration-200",
        overVideo ? "bg-transparent text-white" : "bg-white text-gray-500"
      )}
      style={{
        minHeight: '100vh',
        width: '100%',
        aspectRatio: 'auto'
      }}
    >
      <Loader2 
        className={cn("h-8 w-8 animate-spin", overVideo ? "text-white" : "text-primary")} 
        style={{ width: '32px', height: '32px' }} 
      />
    </div>
  );
}


















































